<div class="content-page">
    <div class="content-page__header">
        <app-header-banner
                [localAsset]="true"
                bannerText=""
                bannerImage="trip_testimonials.jpg"
        ></app-header-banner>
    </div>
    <div class="accessibility-declaration">
        <h1 class="title">Accessibility Declaration</h1>
        <p class="intro">
            RoutePerfect LTD is a company that provides services in the tourism sector.
            <br/>
            <em>This document is written in the masculine form for convenience only.</em>
        </p>
        <section class="goal">
            <h2>Our Goal</h2>
            <p>
                Our goal is to optimize the use and improve our service regarding accessibility and equal rights for
                people with disabilities. Our accessibility adaptations comply with Regulation 35 in the Regulations on
                Equal Rights for People with Disabilities (Service Accessibility Adaptations) 2013, to level AA, subject
                to changes and adaptations made in the Israeli Standard Document (IS 5568) and in accordance with the
                WCAG2.0 standard of the World Wide Web Consortium (W3C).
            </p>
            <p>
                <a href="https://www.w3.org/TR/WCAG20/" target="_blank">View the WCAG 2.0 document here</a>.
            </p>
        </section>

        <section class="features">
            <h2>Accessibility Features Available on Our Website</h2>
            <ul>
                <li>Support for all standard browsers (Chrome, Firefox, Safari, Edge).</li>
                <li>The website content is written in clear language, and readable fonts are used.</li>
                <li>The website structure is built with headings, paragraphs, and lists.</li>
                <li>Navigation on the website is simple and convenient, with clear and accessible menus.</li>
                <li>Links on the site are clear and explain where they lead after clicking.</li>
                <li>Links at the top of the page allow skipping to content.</li>
                <li>Textual descriptions for images and icons for assistive technologies.</li>
                <li>The site is adapted for different working environments with varying
                    resolutions (responsiveness)
                </li>
                <li>Stop and play buttons for video galleries.</li>
                <li>ARIA rules have been implemented to help interpret the website content more accurately and
                    effectively.
                </li>
                <li>Accessibility of menus, forms, and fields, header hierarchy, tab components, pop-up windows, and
                    more.
                </li>
            </ul>
        </section>

        <section class="display">
            <h2>Changing the Website Display</h2>
            <p>
                You can enlarge or reduce the display by pressing "CTRL" with the mouse wheel or "+" / "-". Font size
                can be adjusted using the accessibility menu. Navigation can also be operated using the "TAB" key and
                activated with the "Enter" key.
            </p>
        </section>

        <section class="visual-hearing">
            <h2>Site Adaptation for Visually and Hearing Impaired Users</h2>
            <ul>
                <li>Basic visual enlargement tools.</li>
                <li>Voice recognition software available.</li>
                <li>Voice recognition packages for operating systems.</li>
            </ul>
        </section>

        <section class="limitations">
            <h2>Accessibility Limitations</h2>
            <p>
                While we strive to ensure all pages are accessible, some external advertisements or pages may lack
                complete accessibility. We are working to improve this.
            </p>
        </section>

        <section class="contact">
            <h2>Encountered a Problem? We're Here to Help!</h2>
            <p>
                <strong>Accessibility Contact Details:</strong>
            </p>
            <p>
                Name: Danny Halperin <br/>
                Phone: <a href="tel:+441952987225">+44 1 95 298 7225</a> <br/>
                Email: <a href="mailto:support@routeperfect.com">{{'support@routeperfect.com'}}</a>
            </p>
        </section>
    </div>
    <app-start-planing-mobile></app-start-planing-mobile>
</div>
